<template><div><h1>VUX V2.4.1 released</h1>
<h2><a href="/en/components/datetime.html">Datetime</a></h2>
<ul><li>[fix] Re-render when readonly is changed #1593</li>
<li>[feature] Support prop:default-selected-value #1576</li>
</ul>
<h2><a href="/en/components/picker.html">Picker</a></h2>
<ul><li>[fix] Fix a bug caused by unexpected end of json value #1584</li>
</ul>
<h2><a href="/en/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[fix] popup-picker-header add touchmove.prevent event #1596</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.4.1 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.4.1-109.vue?514df855